<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="4">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001390') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001137')"
						paramKey="powLnCd"
						:options="powLnList"
						:propData="searchParams.powLnCd"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC001422')"
						paramKey="powBttmInfmNo"
						@commInput="setSearchParam"
						:clearable="true"
						:propData="searchParams.powBttmInfmNo"
					>
					</search-input>
				</el-col>
				<!--최종보기-->
				<el-col :span="3">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">&nbsp;</span>
						<div>
							<el-checkbox @input="value => onCheck('lastYn', value)">{{ getMessage_('QWCC001886') }}</el-checkbox>
						</div>
					</div>
				</el-col>
				<!-- 진행상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001094')"
						paramKey="pgsStCd"
						@commChange="setSearchParam"
						:options="getPgsStPtCdList_"
						:propData="searchParams.pgsStCd"
					></select-combo>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { searchDateRange: [] };
	},
	components: { SelectCombo, SearchInput },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			this.getPowTourSttsManagements_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			// try {
			// 	this.$sf_toggleLoading(true);
			// 	this.getPowTourSttsManagements_();
			// } catch (error) {
			// 	console.log('error11111111111111111111111111 >>>>>>>>>>>>>>>>>>>>>>>>> ', error);
			// 	this.$sf_toast({
			// 		type: 'error',
			// 		message: error.message
			// 	});
			// } finally {
			// 	this.$sf_toggleLoading(false);
			// }
		},
		onCheck(key, value) {
			// console.log(value);
			if (value) {
				this.setSearchParam_({ key, value: 'Y' });
			} else {
				this.setSearchParam_({ key, value: 'N' });
			}
		}
	},
	async created() {
		try {
			this.searchDateRange = [...this.getSearchDates_];
			//라인 콤보
			await this.getCommCodes_({ key: 'powLnList', codeType: 'OCCU_PL' });
			await this.getCommCodes_({ key: 'pgsStPtCdList', codeType: 'PGS_ST_PT' }); //진행상태
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setSearchParam_({ key: 'strDt', value: '' });
				this.setSearchParam_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setSearchParam_({ key: 'strDt', value: strDt });
				this.setSearchParam_({ key: 'endDt', value: endDt });
			}
		}
	}
};
</script>

<style></style>
